var IconType = {
    Img: 'img',
    Indicator: 'indicator',
};

export { IconType };
